import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AlertService, AuthenticationService, ConstantService, UserService } from '@app/_services';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LostFoundService } from '@app/_components/lost-found/lost-found.service';
import { FormArray, FormControl, FormGroup, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {Location} from '@angular/common';
import * as moment from "moment";
import { Calendar } from 'primeng/calendar';
import { ChangeDetectorRef } from '@angular/core';
import { ReservationService } from '@app/_components/reservation/reservation.service';

const numberFormatter = new Intl.NumberFormat('en-US',{
  maximumFractionDigits: 2
});

@Component({
    selector: 'app-additional-payment',
    templateUrl: './additional-payment.component.html',
    styleUrls: ['./additional-payment.component.css'],
    standalone: false
})
export class AdditionalPaymentComponent implements OnInit {

  updatedCheckInDate: Date;
	checkOutDateBasedOnCheckinDate: Date;
	isDateLessThanCheckinDate = false;
  isDisplayClearDates = false;
  minDate: Date;
	maxDate: Date;

	// form
	formLoading = false;

	// nav
	tabIndex: number;
    numAdults: any[];
	workOrders: any;
    lostFounds: any;

	 // forms
	 form2: UntypedFormGroup;
	 formAlert: String;
	 formTitle: String;

   isGuestAgreeForCreditCard = false;
	disabledBookReservationButton = false;
	showPaymentSuccess = false;
	chargeSubmitting = false;

   @Input() reservation: any;
   @Input() paymentSources: any;
   @Output() doUpdate = new EventEmitter<any>();
  year: number;
  years: any[]=[];
  paymentCreditCardRequests: any[]=[];

  // Deferred-capture popup modes:
  //   deferredCapture=false -> classic "Run Payment" (admin picks any Action from
  //                            the standard 5-option dropdown).
  //   deferredCapture=true  -> combined "Authorize / Capture" popup. The admin
  //                            picks AO vs PC via a radio toggle inside the
  //                            popup. When PC is selected, a prior-auth dropdown
  //                            appears whose value is sent to the backend as
  //                            transactionId so CreditCardHelper.PRIOR_AUTH_CAPTURE
  //                            can call setTransactionId().
  deferredCapture: boolean = false;
  priorAuths: any[] = [];

  constructor(
		public alertService: AlertService,
		private reservationService: ReservationService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.formTitle = this.data.title;
    this.reservation = this.data.reservation;
    this.paymentSources = this.data.paymentSources;
			this.paymentCreditCardRequests = this.reservationService.paymentCreditCardRequests;
			this.deferredCapture = !!this.data.deferredCapture;
			this.priorAuths = this.data.priorAuths || [];
   }

   cardExpirationMonthMessage: string = "Expiration cannot be in the past";
	travelInsuranceMsg: string = "Travel insurance selection is required";
	guestContractApproveMsg: string = "Acknowledgement is required. Questions? Call (800) 768-6994";
	firstNameMsg: string = "Full name is required";
	lastNameMsg: string = "Last name is required";
	emailAddressMsg: string = "Email address is required";
	validEmailAddressMsg: string = "Valid email is required";
	mobilePhoneMsg: string = "Mobile number is required";
	adrStreetMsg: string = "Address is required";
	adrCitytMsg: string = "City is required";
	adrStateMsg: string = "State or Province is required";
	adrPostalCodeMsg: string = "Postal Code is required";
	adrCountryMsg: string = "Country is required";
	cardHolderNameMsg: string = "Cardholder name is required";
	paymentAddressMsg: string = "Address is required";
	paymentCityMsg: string = "City is required";
	paymentStateMsg: string = "State is required";
	paymentPostalMsg: string = "Postal Code is required";
	paymentProcessAmountMsg: string = "Payment amount is required";
	expirationMonthMsg: string = "Month is required";
	expirationYearMsg: string = "Year is required";
	creditCardNumberMsg: string = "Card number is required";
	cvvCodeMsg: string = "CCV code is required";

   months = [
		{ value: '01', name: 'January' },
		{ value: '02', name: 'February' },
		{ value: '03', name: 'March' },
		{ value: '04', name: 'April' },
		{ value: '05', name: 'May' },
		{ value: '06', name: 'June' },
		{ value: '07', name: 'July' },
		{ value: '08', name: 'August' },
		{ value: '09', name: 'September' },
		{ value: '10', name: 'October' },
		{ value: '11', name: 'November' },
		{ value: '12', name: 'December' }
	];

  validationMessages1 = {
		city: [
			{ type: 'required', message: this.paymentCityMsg }],
		stateOrProvince: [
			{ type: 'required', message: this.paymentStateMsg }],
		postalCode: [
			{ type: 'required', message: this.paymentPostalMsg }],
			paymentAmount: [
			{ type: 'required', message: this.paymentProcessAmountMsg }],
		country: [
			{ type: 'required', message: 'Country is required.' }],
		cardName: [
			{ type: 'required', message: this.cardHolderNameMsg }],
		cardExpirationMonth: [
			{ type: 'required', message: this.expirationMonthMsg }],
		cardExpirationYear: [
			{ type: 'required', message: this.expirationYearMsg }],
		cardNumber: [
			{ type: 'required', message: this.creditCardNumberMsg },
			{ type: 'maxlength', message: '19 characters maximum' },
			{ type: 'minlength', message: '15 characters minimum' }],
		cardSecurityCode: [
			{ type: 'required', message: this.cvvCodeMsg },
			{ type: 'maxlength', message: '3 characters maximum' },
			{ type: 'minlength', message: '4 characters minimum' }],
		cardType: [],
		signName: [
			{ type: 'required', message: 'Enter firstname and lastname is required.' }],
		signEmail: [
			{ type: 'required', message: 'Enter email address.' }],
		iAgree: [{ type: 'required', message: "required" }],
		paymentSourceId:[],
		paymentCreditCardRequestedTransactionType:[]
	};

  ngOnInit(): void {
    this.formBuildForCreditCard();
    let today = new Date();
		let month = today.getMonth();
		let year = today.getFullYear();
		let day = today.getDate();
		this.updatedCheckInDate = today;
		this.minDate = new Date();
		this.maxDate = new Date(year + 3, month, day);
		// this.formBuild();
		this.year = new Date().getFullYear();
		for (let i = 0; i < 10; i++) {
			this.years.push({ name: this.year.toString(), value: this.year.toString() });
			this.year = this.year + 1;
		}
  }

  	// book reservation form builder
	formBuildForCreditCard() {
		this.form2 = this.formBuilder.group({
			//passed from quote
			reservationId: [this.reservation?.reservationId],
			orderId: [this.reservation?.order?.orderId],

			paymentSource: this.formBuilder.group({
				cardName: [this.reservation?.guestProfile?.firstName+" "+this.reservation?.guestProfile?.lastName, Validators.required],
				cardExpirationMonth: ['', Validators.required],
				cardExpirationYear: ['', Validators.required],
				cardNumber: ['', Validators.required],
				cardSecurityCode: new FormControl('', [Validators.required]),
				cardType: [],
				addressLine1: [],
				city: [],
				stateOrProvince: [],
				postalCode: ['', Validators.required],
				paymentAmount: [this.formatNumber(this.reservation?.invoice?.totalOutstandingBalance), Validators.required],
				country: ['US'],
				paymentType: ['CR'],
				iAgree: [''],
				paymentSourceId: [],
				// In deferred-capture mode the admin picks AO or PC via a radio
				// toggle in the popup; default to AO so a single click on Make
				// Payment without changing anything performs an Authorize Only.
				paymentCreditCardRequestedTransactionType: [this.deferredCapture ? 'AO' : null],
				// Used only when (deferredCapture && transactionType === 'PC').
				// Sent to backend as transactionId so CreditCardHelper.PRIOR_AUTH_CAPTURE
				// can call setTransactionId() against the original auth.
				priorAuthTxnId: [null]
			}),
			contract: this.formBuilder.group({
				signName: [''],
				signEmail: [''],
				signBase64: [],
			}),
		});
	}

  formatNumber(number: any): any{
		if (number) {
			return numberFormatter.format(number);
		}
		else {
			'';
		}
	}

  makeAdditionalPayment() {
		if (this.chargeSubmitting) { return; }
		try {
			// stop here if form is invalid
			this.form2.markAllAsTouched();
			if(this.form2.value.paymentSource.iAgree == "" || this.form2.value.paymentSource.iAgree == null || this.form2.value.paymentSource.iAgree == false || this.form2.value.paymentSource.iAgree == undefined){
				this.isGuestAgreeForCreditCard = true;
				this.disabledBookReservationButton = false;
				return;
			}else{
				this.isGuestAgreeForCreditCard = false;
				// this.form2.value.paymentSource.iAgree == "Yes"
			}
			if (this.form2.invalid) {
				this.disabledBookReservationButton = false;
				return;
			}

			this.chargeSubmitting = true;
			this.formLoading = true;
			// set contract data into form contract
			// this.form1.value.contract.signBase64 = this.signBase64;
			console.log("this.form1.value this.form1.value " + JSON.stringify(this.form2.value));
			const chosenTxnType = this.form2.value.paymentSource?.paymentCreditCardRequestedTransactionType;
			// In deferred-capture mode, PC requires a Prior Auth selection. Block
			// here with a friendly message rather than letting the backend reject.
			if (this.deferredCapture && chosenTxnType === 'PC'
					&& !this.form2.value.paymentSource?.priorAuthTxnId) {
				this.confirmationService.confirm({
					header: 'Prior Auth Required',
					message: 'Pick a prior authorization to capture against, or switch to Authorize Only.',
					icon: 'fa fa-exclamation-triangle',
					rejectVisible: false,
					acceptLabel: 'Close',
					accept: () => { this.disabledBookReservationButton = false; }
				});
				this.chargeSubmitting = false;
				this.formLoading = false;
				return;
			}

			const paymentData = {
				"reservationId": this.reservation.reservationId,
				"orderId": this.reservation?.order?.orderId,
				// transactionId lives at the ROOT of ReservationRequestApi (line 87 of
				// the backend DTO, read by addCreditPayment via getTransactionId()).
				// Sending it inside paymentSource won't bind. For PC, pass the chosen
				// prior-auth transaction id here.
				"transactionId": chosenTxnType === 'PC'
					? this.form2.value.paymentSource?.priorAuthTxnId
					: undefined,
				"paymentSource": {
					"firstName": this.reservation?.guestProfile?.firstName,
					"lastName": this.reservation?.guestProfile?.lastName,
					"paymentAmount": this.form2.value?.paymentSource?.paymentAmount.replace(/[\$,]/g, ''),
					"cardNumber": this.form2.value?.paymentSource?.cardNumber,
					"cardSecurityCode": this.form2.value?.paymentSource?.cardSecurityCode != null ? this.form2.value?.paymentSource?.cardSecurityCode.toString() : '',
					"cardExpirationYear": this.form2.value?.paymentSource?.cardExpirationYear,
					"cardExpirationMonth": this.form2.value?.paymentSource?.cardExpirationMonth,
					"stateOrProvince": this.reservation?.guestProfile?.adrState,
					"postalCode": this.form2.value?.paymentSource?.postalCode,
					"zip": this.form2.value?.paymentSource?.postalCode,
					"city": this.reservation?.guestProfile?.adrCity,
					"countryName": this.reservation?.guestProfile?.adrCountry,
					"stateName": this.reservation?.guestProfile?.adrState,
					"email": this.reservation?.guestProfile?.emailAddress,
					"phone": this.reservation?.guestProfile?.mobilePhone,
					"addressLine1": this.reservation?.guestProfile?.adrStreet,
					"paymentTypeId": 1,
					"cardName": this.form2.value?.paymentSource?.cardName,
					"creditCardTypeId": 1,
					"paymentDescription": "XXX",
					"cardType": "VISA",
					"country": "US",
					"paymentType": "CR",
					"iAgree": this.form2.value.paymentSource.iAgree == true ? "Yes" : "No",
					"paymentSourceId": this.form2.value.paymentSource?.paymentSourceId,
					"transactionType": chosenTxnType,
				},
				"contract": {
					"signName": "KBm KBmresorts null",
					"signEmail": "dev@kbmresorts.cpm"
				},
			}
			// call api related create booking
			this.reservationService.makeAdditionalPaymentByAdmin(paymentData)
				.subscribe(
					(res: any) => {
						this.chargeSubmitting = false;
						this.formLoading = false;
            // this.doUpdate.emit(null);
						if(res.data?.reservationSummary?.reservationApiList[0]?.status == "INVALID"){
							this.confirmationService.confirm({
								header: 'Payment Error',
								message: res.data?.reservationSummary?.reservationApiList[0]?.errors[0]?.message,
								icon: 'fa fa-exclamation-triangle',
								rejectVisible: false,
								acceptLabel: 'Close',
								accept: () => {
									//Actual logic to perform a confirmation
									this.disabledBookReservationButton = false;
									this.formLoading = false;
								}
							});
						}else{
							this.showPaymentSuccess = true;
						}
					},
					(err: any) => {
						// Do NOT reset formLoading or disabledBookReservationButton on error.
						// A 504 means the payment authorization may have already been processed.
						// Keep the button disabled to prevent a duplicate charge.
						this.chargeSubmitting = false;
						this.confirmationService.confirm({
							header: 'Payment Error — Refresh Required',
							message: 'A network error occurred. The payment may have already been processed. Please refresh the page and check the reservation before trying again.',
							icon: 'fa fa-exclamation-triangle',
							rejectVisible: false,
							acceptLabel: 'Close',
							accept: () => {
								//Actual logic to perform a confirmation
							}
						});

						console.log('makeAdditionalPaymentByAdmin FAIL: ' + JSON.stringify(err));
					},
					() => { });
		} catch (error) {
			this.chargeSubmitting = false;
			this.formLoading = false;
		}
	}

  //Close open dialog box
	closePaymentDialog() {
		this.showPaymentSuccess = false;
		window.location.reload();
	}

  // Checked mark i agree button
	checkedIAgree(event: any, validationName: any) {
		// clear signature pad

		// Set toggle like I agree by user checked or not
		// this.isGuestAgreeForCreditCard = event.target.checked;
		console.log("gggggg :" + event.target.checked);
		this.form2.value.paymentSource.iAgree = event.target.checked;
		if (event.target.checked) {
			this.isGuestAgreeForCreditCard = false;
			console.log("yyyyyyy :" + event.target.checked);
			// if (validationName == "iAgree" && this.errorList.indexOf(this.guestContractApproveMsg) !== -1) {
			// 	this.updateValidation(this.guestContractApproveMsg);
			// }
		} else {
			this.isGuestAgreeForCreditCard = true;
			// this.errorList.push(this.guestContractApproveMsg);
			// this.errorMessages = "";
			// for (let i = 0; i < this.errorList.length; i++) {
			// 	this.errorMessages += this.errorList[i] + "<br>";
			// }
		}

	}

  selectPaymentSource(event: any) {
		if (event?.value) {
			const paymentSource = this.paymentSources.find((e: any) => e.value == event.value);
			this.form2.get('paymentSource')?.get('cardName').setValue(paymentSource?.paymentSource?.billingName);
			this.form2.get('paymentSource')?.get('cardExpirationMonth').setValue(paymentSource?.paymentSource?.creditCardExpirationMonth);
			this.form2.get('paymentSource')?.get('cardExpirationYear').setValue(paymentSource?.paymentSource?.creditCardExpirationYear);
			this.form2.get('paymentSource')?.get('cardNumber').setValue(paymentSource?.paymentSource?.creditCardNumber);
			if(paymentSource?.paymentSource?.creditCardSecurityCode != null && paymentSource?.paymentSource?.creditCardSecurityCode != undefined && paymentSource?.paymentSource?.creditCardSecurityCode != ""){
			this.form2.get('paymentSource')?.get('cardSecurityCode').setValue(paymentSource?.paymentSource?.creditCardSecurityCode.toString());
			}
			this.form2.get('paymentSource')?.get('postalCode').setValue(paymentSource?.paymentSource?.billingPostalCode);
		}
		else {
			return '';
		}
	}

}
